import {Injectable} from '@angular/core';
import {VisbosService} from "../../core/visbos-core/graphql/visbos.service";
import {Apollo} from "apollo-angular";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../../shared/redux-store";
import {SessionActions} from "../../shared/actions";
import gql from "graphql-tag";
import {Observable} from "rxjs/Observable";
import {variable} from "@angular/compiler/src/output/output_ast";
import {ApolloQueryResult} from "apollo-client";

export const sensorFragments = {
  sensorFields: gql`
    fragment SensorFields on TemperatureSensor {
      cuid label is_editable
      administration_unit {cuid label}
      created_at updated_at
      internal_sensor_id sensor_model
      description
      is_active
      min_limit max_limit
      temperature_unit
    }`,
  logEntryFields: gql`
    fragment LogEntryFields on TemperatureLogEntry {
      cuid label
      is_editable
      created_at updated_at
      temperature_value
      min_limit max_limit
      temperature_unit
      is_critical
      has_triggered_notifications
    }
  `
};

export const GetSensorsOverviewQuery = gql`
  query GetTemperatureSensors(
  $adminUnitCuid:String, $sensorCuid:String) {
    sensors(adminUnitCuid:$adminUnitCuid, sensorCuid:$sensorCuid) {
      ...SensorFields
      latest_value {
        ...LogEntryFields
      }
    }
  }
  ${sensorFragments.sensorFields}
  ${sensorFragments.logEntryFields}
`;

export const UpdateTemperatureSensorMutation = gql`
  mutation UpdateTemperatureSensorMutation($cuid: String!, $input: TemperatureSensorInput!) {
    updateTemperatureSensor(cuid: $cuid, sensorInput: $input) {
      ...SensorFields
    }
  }
  ${sensorFragments.sensorFields}
`;

export const GetSensorDetailQuery = gql`
  query GetTemperatureSensorDetails(
  $adminUnitCuid:String, $sensorCuid:String,
  $critical: Boolean, $start:String, $end:String) {
    sensors(adminUnitCuid:$adminUnitCuid, sensorCuid:$sensorCuid) {
      ...SensorFields
      log_entries(only_critical:$critical, start_time:$start, end_time:$end) {
        ...LogEntryFields
      }
    }
  }
  ${sensorFragments.sensorFields}
  ${sensorFragments.logEntryFields}
`;

@Injectable()
export class SensorService extends VisbosService {

  constructor(apollo: Apollo, ngRedux: NgRedux<IAppState>, sessionActions: SessionActions) {
    super(apollo, ngRedux, sessionActions);
  }

  public getSensors(adminUnitCuid?: string | Observable<string>) {
    return this.fetchItems({
      query: GetSensorsOverviewQuery,
      variables: {
        adminUnitCuid: adminUnitCuid || this.activeAdminUnitCuid$
      }
    });
  }

  public getSensorDetails(sensorCuid: string | Observable<string>,
                          onlyCritical?: boolean | Observable<boolean>,
                          startDate?: Date | Observable<Date>,
                          endDate?: Date | Observable<Date>) {
    return this.fetchItems({
      query: GetSensorDetailQuery,
      variables: {
        sensorCuid: sensorCuid,
        critical: onlyCritical,
        start: startDate,
        end: endDate
      }
    });
  }

  public updateTempratureSensor(sensorCuid: string, sensorData: any): Observable<ApolloQueryResult<any>> {
    return this.mutate({
      mutation: UpdateTemperatureSensorMutation,
      variables: {
        cuid: sensorCuid,
        input: sensorData
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/sensors/services/sensor.service.ts